import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ILabel } from '../models/labels.interface';
import { LabelsService } from 'src/app/services/labels.service';
import { WellsService } from 'src/app/services/wells.service';
import { IWell } from '../models/wells.inteface';
import { IonAccordionGroup, PopoverController } from '@ionic/angular';
import { DOCUMENT } from '@angular/common';
import { MultipleSelectPpopoverComponent } from '../../multiple-select-ppopover/multiple-select-ppopover.component';
import { DMUSelectionService } from 'src/app/services/dmu-selection.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ToastController } from '@ionic/angular';
@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
})
export class GraphComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() labelListGraph: ILabel[] = [];
  @Input() wellList: IWell[] = [];
  @Input() rangeDate!: any;
  @Input() isOpenToast!: boolean;
  @Input() dmuSelected: string = ''; 
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() fullScreenGraphEvent = new EventEmitter<boolean>();
  @ViewChild('accordionGroup', { static: true })
  accordionGroup!: IonAccordionGroup;

  public data: any[] = [];
  public monthly: any;
  public labelIds: any[] = [];
  public labelsSelected: any[] = [];
  public dmuIds: string[] = [];
  public fullScreen: boolean = false;
  public touchSerie: boolean = false;
  public touchDmu: boolean = false;
  public  widthScreen = window.innerWidth;
  public accordionShow: boolean = true;
  public minValue = new Date(
    new Date().getFullYear() - 1,
    new Date().getMonth(),
    new Date().getDate()
  );
  public toastButtons = [
    {
      text: 'Cerrar',
      role: 'cancel',
    },
  ];

  public startDate: Date | undefined;
  public endDate: Date | undefined;

  zoomLevel = 1;
  mouseX = 0;
  mouseY = 0;
  zoomStyles = {};
  scale = 1;
  isZoom: boolean = false;
  isZooming: boolean = false;
  private isGrabbing = false;
  private offsetX = 0;
  private offsetY = 0;
  private initialContentY = 0;
  private initialContentX = 0;

  private scrollThreshold = 1.5;

  temporalidadList = [
    { label: 'Diaria', value: 'daily' },
    { label: 'Mensual', value: 'monthly' },
    { label: 'Anual', value: 'yearly' },
  ];
  standardizationList = [
    { label: 'Normal', value: 'normal' },
    { label: 'Re-escalamiento', value: 're-escalamiento' },
  ];
  orderList = [
    {label: 'DMU', value: 'dmu'},
    {label: 'Serie', value: 'serie'},
  ];
  selectedOptions: string[] = [];
  customOption: string = '';

  temporalidadSelected: string = 'daily';
  standardizationSelected: string = 'normal';
  orderSelected: string = 'dmu';
  isOpenPopover: boolean = false;
  platform = navigator.platform.toLowerCase();
  toast!: HTMLIonToastElement
  @ViewChild('customOptionTemplate') customOptionTemplate!: TemplateRef<any>;

  @ViewChild('dragItem') dragItem!: ElementRef;
  @HostListener('window:wheel', ['$event'])
  onMouseWheel = (event: WheelEvent) => {
    const isMouseOverDiv = this.elementRef.nativeElement.contains(event.target);
    if (event.ctrlKey && isMouseOverDiv) {
      this.isZooming = true;
      this.isGrabbing = false;
      if (event.deltaY > 0) {
        // Zoom out
        this.zoomLevel -= 0.1;
      } else {
        // Zoom in
        this.zoomLevel += 0.1;
      }
      // Limit zoom level within a range (optional)
      this.zoomLevel = Math.min(Math.max(0.7, this.zoomLevel), 3);

      this.updateZoomStyles();
    }
  };

  @HostListener('window:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (!this.isZooming) {
      this.isGrabbing = true;
      this.offsetX = event.clientX;
      this.offsetY = event.clientY;
    }
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    const isMouseOverDiv = this.elementRef.nativeElement.contains(event.target);
    if (this.isGrabbing && isMouseOverDiv && this.zoomLevel != 1) {
      const deltaX = event.clientX - this.offsetX;
      const deltaY = event.clientY - this.offsetY;
      const newContentX = this.initialContentX + deltaX;
      const newContentY = this.initialContentY + deltaY;
      this.dragItem.nativeElement.style.transform = `scale(${this.zoomLevel}) translate(${newContentX}px, ${newContentY}px)`;
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (this.isGrabbing) {
      const deltaX = event.clientX - this.offsetX;
      const deltaY = event.clientY - this.offsetY;

      this.initialContentX += deltaX;
      this.initialContentY += deltaY;
    }
    this.isGrabbing = false;
    this.isZooming = false;
  }

  preventWheelScroll(event: WheelEvent) {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  }

  updateZoomStyles() {
    const transform =
      this.initialContentX || this.initialContentY
        ? `scale(${this.zoomLevel}) translate(${this.initialContentX}px, ${this.initialContentY}px)`
        : `scale(${this.zoomLevel})`;
    this.zoomStyles = {
      transform: transform,
      position: 'relative',
    };
  }

  constructor(
    private _labelsService: LabelsService,
    @Inject(DOCUMENT) private document: Document,
    private elementRef: ElementRef,
    private popoverController: PopoverController,
    private _selectionService: DMUSelectionService,
    public loadingService: LoadingService,
    public toastController: ToastController
  ) {
    window.addEventListener('wheel', this.preventWheelScroll, {
      passive: false,
    });
  }
  ngAfterViewInit(): void {
    this.dragItem.nativeElement.addEventListener(
      'mouseover',
      this.onMouseOver,
      false
    );
    this.dragItem.nativeElement.addEventListener(
      'mouseout',
      this.onMouseOut,
      false
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['dmuSelected']?.currentValue){
      setTimeout(() => {
        console.log("ENTRA", changes['dmuSelected']);
        if(changes['dmuSelected'].firstChange){
          this.dmuIds = []
          this.labelsSelected = []
        }
        !this.dmuIds.includes(changes['dmuSelected'].currentValue) && this.dmuIds.push(changes['dmuSelected'].currentValue)
      
      }, 10);
    }
  }

  ngOnInit() {
    this.getDmuSelected()
    this.getSeriesSelected();
    this.presentToast()
    this.resetFilters()
  }

  getDmuSelected(){
    this._selectionService.selectedOptions$.subscribe((options) => {
      this.dmuIds = options;
    });
  }

  getSeriesSelected(){
    this._selectionService.selectedSeries$.subscribe((options) => {
      this.labelIds = options.map((option) => option.id);
      this.labelsSelected = options.map((option) => option.name);
    });
  }

  clearParams(){
    this.zoomLevel = 1;
    this.initialContentX = 0;
    this.initialContentY = 0;
  }
  getGraphData() {
    this.clearParams()
    this.updateZoomStyles();
    //this.toggleAccordion();
    const rangeDate = {
      start_date: this.startDate?.toISOString().split('T')[0],
      end_date: this.endDate?.toISOString().split('T')[0],
      dmu: this.dmuIds.toString(),
      date_aggregation: this.temporalidadSelected,
    };
    this.loadingService.show();
    this._labelsService
      .getGraphData(this.labelIds.toString(), rangeDate,null, false)
      .subscribe((graphs) => {
        this.data = graphs;
        this.loadingService.hide();
      });
  }

  closeMenu() {
    this.closeEvent.next(false);
    this.fullScreenGraphEvent.next(false);
    this.fullScreen = false;
    
    this.toast.dismiss();
    this.resize();
    
  }

  resetFilters(){
    this.dmuIds = []
    this.labelsSelected = [];
  }

  setFullScreen() {
    this.fullScreen = !this.fullScreen;
    this.fullScreenGraphEvent.next(this.fullScreen);
    this.resize();
  }

  resize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  reset() {
    this.labelIds = [];
  }

  setRangeDate(event: Date, type = 'end') {
    type == 'start' ? (this.startDate = event) : (this.endDate = event);
  }

  onMouseOver(event: MouseEvent) {
    this.isZoom = true;
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
  }

  onMouseOut(event: MouseEvent) {
    this.isZoom = false;
  }

  toggleAccordion = () => {
    const nativeEl = this.accordionGroup;
    nativeEl.value === 'first'
      ? (nativeEl.value = undefined)
      : (nativeEl.value = 'first');
    this.accordionShow = nativeEl.value === 'first' ? true : false;
  };

  async openSelectPopover() {
    if (!this.isOpenPopover) {
      this.isOpenPopover = true;
      const popover = await this.popoverController.create({
        component: MultipleSelectPpopoverComponent,
        mode: 'md',
        componentProps: {
          options: this.wellList,
          selectedOptions: this.dmuIds,
          labelSearch: 'Buscar DMU',
          id:'dmu'
        },
        showBackdrop: false,
        cssClass: 'custom-popover',
        event: event,
        translucent: false,
      });

      await popover.present();
      const { data } = await popover.onWillDismiss();
      this.touchDmu = true
      this.isOpenPopover = false;
      if (data && data.selectedOptions) {
        this.dmuIds = data.selectedOptions;
        this.customOption = ''; // Clear customOption after popover dismisses
      }
    }
  }

  addCustomOption() {
    const customValue = this.customOption.trim();
    if (customValue && !this.selectedOptions.includes(customValue)) {
      this.selectedOptions.push(customValue);
      this.customOption = ''; // Clear customOption after adding the value
    }
  }

  getMessage() {
    return `Utilice ${
      this.platform.includes('mac') ? 'Cmd ⌘' : 'Ctrl'
    } +  desplazamiento para hacer zoom en la grafica`;
  }

  async openSelectSeries() {
    if (!this.isOpenPopover) {
      this.isOpenPopover = true;
      console.log("YYES", this.labelListGraph);
      
      const popover = await this.popoverController.create({
        component: MultipleSelectPpopoverComponent,
        mode: 'md',
        componentProps: {
          options: this.labelListGraph,
          selectedOptions: this.labelsSelected,
          labelSearch: 'Buscar Series',
          id: 'series'
        },
        showBackdrop: false,
        cssClass: 'custom-popover',
        event: event,
        translucent: false,
      });

      await popover.present();
      const { data } = await popover.onWillDismiss();

      this.isOpenPopover = false;
     
      
     

      popover.onDidDismiss().then((result) => {
        this.touchSerie = true
        if (result.data && result.data.selectedOptions) {
          // Maneja las opciones seleccionadas aquí
          this.selectedOptions = result.data.selectedOptions;
        }
      });

      
    }
  }

  async presentToast() {
    this.toast = await this.toastController.create({
      message: this.getMessage(),
      buttons: this.toastButtons,
      cssClass:'custom-toast-content'
    });
    this.toast.present();
  }
}
